import Vue from 'vue'
import { loadModules } from 'esri-loader'
import store from '@/store'
import { mapState } from 'vuex'
import { gmapApi } from 'gmap-vue'
import { _ } from 'vue-underscore'
import request from '@/utils/request'
export default Vue.extend({
  data() {
    return {
      loading: false,
      assetColors: [
        [241, 140, 120],
        [184, 220, 148],
        [84, 130, 53],
        [179, 93, 132],
        [150, 208, 238],
        [86, 148, 194],
        [255, 217, 102],
        [210, 160, 0],
        [201, 201, 201],
        [234, 173, 122],
        [93, 199, 194],
        [241, 163, 243]
      ],
      usedTypos: [],
      activetypolegend: false,
      colorByProperty: 'Asset_Features_03',
      rings_search: [[]],
      showwmspop: false,
      wmsdata: {
        foglio: ''
      }
    }
  },
  computed: {
    ...mapState('location', {
      position: (state) => state.position
    }),
    ...mapState('user', {
      activeNav: (state) => state.activeNav
    }),
    google: gmapApi,
    isvaluations: function() {
      return this.activeNav === 'valuation'
    },
    isportfolio: function() {
      return this.activeNav === 'portfolio'
    },
    ...mapState('valuations', {
      currentComparables: (state) => state.currentComparables,
      currentFilterValuations: (state) => state.currentFilter,
      selectedcomparables: (state) => state.selectedcomparables
    }),
    ...mapState('portfolio', {
      currentAssets: (state) => state.currentportfolio
    }),
    ...mapState('pois', {
      currentMapPois: (state) => state.MapPois
    })
  },
  watch: {
    position: function() {
      this.centermapposition()
    },
    isvaluations: function() {
      this.showhidevaluations()
    },
    isportfolio: function() {
      this.showhideportfolio()
    },
    currentComparables: function() {
      this.drawcomparables()
    },
    currentAssets: function() {
      this.drawassets(false)
    },
    currentMapPois: function() {
      this.drawpois()
    }
  },
  created() {
    const vm = this
    vm.createmap()
  },
  methods: {
    showhidevaluations() {
      const vm = this
      vm.assetGraphicView.visible = vm.isvaluations
    },
    showhideportfolio() {
      const vm = this
      if (vm.isportfolio) {
        vm.portassetGraphicView.visible = true
        vm.activetypolegend = true
      } else {
        vm.portassetGraphicView.visible = false
        vm.activetypolegend = false
      }
    },
    createmap() {
      const vm = this
      loadModules(
        [
          'esri/config',
          'esri/identity/IdentityManager',
          'esri/layers/GraphicsLayer',
          'esri/Map',
          'esri/views/MapView',
          'esri/core/watchUtils',
          'esri/layers/FeatureLayer',
          'esri/layers/WMSLayer',
          'esri/geometry/Extent',
          'esri/geometry/SpatialReference',
          'esri/layers/support/WMSSublayer',
          'esri/core/urlUtils',
          'esri/Basemap'
        ],
        { css: true }
      ).then(
        ([
          esriConfig,
          IdentityManager,
          GraphicsLayer,
          ArcGISMap,
          MapView,
          watchUtils,
          FeatureLayer,
          WMSLayer,
          Extend, SpatialReference, WMSSublayer, urlUtils, Basemap
        ]) => {
          console.log('createmap wms')

          esriConfig.request.corsEnabledServers.push('ows.mundialis.de')
          const proxyurl = window._env_.VUE_APP_BRAINS_API.replace('/api', '') + '/brainsmaps'
          urlUtils.addProxyRule({
            urlPrefix: 'wms.cartografia.agenziaentrate.gov.it',
            proxyUrl: proxyurl
          })
          // debugger
          esriConfig.request.interceptors.push({
            urls: 'https://wms.cartografia.agenziaentrate.gov.it/',
            /*
            before: function(params) {
              debugger
            },
            */
            headers: {
              'Authorization': 'Bearer ' + store.state.user.token
            }
          })

          const wkid = 4258
          vm.emptyspatialreference = new SpatialReference({ wkid: wkid })
          vm.emptyextent = new Extend(
            5.93, 34.76, 18.99, 47.1,
            vm.emptyspatialreference)

          var wmslayer = new WMSLayer({
            url: 'https://wms.cartografia.agenziaentrate.gov.it/inspire/wms/ows01.php?',
            sublayers: [
              new WMSSublayer({ name: 'province', title: 'province', visible: true, spatialReference: vm.emptyspatialreference }),
              new WMSSublayer({ name: 'CP.CadastralZoning', title: 'CadastralZoning', visible: true, spatialReference: vm.emptyspatialreference }),
              new WMSSublayer({ name: 'strade', title: 'strade', visible: true, spatialReference: vm.emptyspatialreference }),
              new WMSSublayer({ name: 'acque', title: 'acque', visible: true, spatialReference: vm.emptyspatialreference }),
              new WMSSublayer({ name: 'CP.CadastralParcel', title: 'CadastralParcel', visible: true, spatialReference: vm.emptyspatialreference }),
              new WMSSublayer({ name: 'fabbricati', title: 'fabbricati', visible: true, spatialReference: vm.emptyspatialreference }),
              new WMSSublayer({ name: 'vestizioni', title: 'vestizioni', visible: true, spatialReference: vm.emptyspatialreference })
            ],
            visibleLayers: ['province'],
            version: '1.1.1',
            visible: true,
            spatialReference: vm.emptyspatialreference,
            opacity: 7
          })

          var wmsbackground = new WMSLayer({
            url: 'https://ows.mundialis.de/services/service?',
            sublayers: [
              new WMSSublayer({ name: 'TOPO-OSM-WMS', title: 'wms_background', visible: true, spatialReference: vm.emptyspatialreference })
            ],
            visibleLayers: ['TOPO-OSM-WMS'],
            version: '1.1.1',
            visible: true
          })

          vm.currentMap = new ArcGISMap({
          })

          vm.currentMapView = new MapView({
            container: 'viewDivwms',
            map: vm.currentMap,
            center: [-3.68, 40.51],
            zoom: 5,
            spatialReference: {
              wkid: wkid
            }
          })

          vm.currentMapView.spatialReference = vm.emptyspatialreference
          vm.currentMapView.extent = vm.emptyextent

          vm.currentMap.add(wmsbackground)

          vm.currentMap.add(wmslayer)
          vm.portassetGraphicView = new GraphicsLayer({
            graphics: [],
            title: 'assetpoints',
            popupTemplate: {
              content: 'pp'
            },
            spatialReference: {
              wkid: wkid
            }
          })

          vm.assetGraphicView = new GraphicsLayer({
            graphics: [],
            title: 'comparablepoints',
            popupTemplate: {
              content: 'kk'
            },
            spatialReference: {
              wkid: wkid
            }
          })

          vm.currentMap.add(vm.assetGraphicView)
          vm.currentMap.add(vm.portassetGraphicView)

          vm.currentMapView.when(function() {
            vm.currentMapView.on('click', function(evt) {
              if (evt.button === 2) {
                evt.stopPropagation()
                const place = {
                  geometry: {
                    location: {
                      lat: function() {
                        return evt.mapPoint.latitude
                      },
                      lng: function() {
                        return evt.mapPoint.longitude
                      }
                    }
                  },
                  formatted_address: 'frommapclick'
                }
                vm.loading = true
                vm.$store.dispatch('location/searchlocations', place).then(() => {
                  const location = {
                    lat: parseFloat(evt.mapPoint.latitude),
                    lng: parseFloat(evt.mapPoint.longitude)
                  }
                  var geocoder = new vm.google.maps.Geocoder()
                  vm.loading = false
                  geocoder.geocode({ 'location': location }, function(results, status) {
                    if (status === vm.google.maps.GeocoderStatus.OK) {
                      const loc = results[0]
                      vm.$root.$emit('locationaddressfrommap', loc)
                    } else {
                      console.log('address not found')
                      // debugger
                    }
                  })
                }).catch(() => {
                  // debugger
                  vm.loading = false
                  vm.$message({
                    message: vm.$t('locationSelector.invalidlocation'),
                    type: 'error'
                  })
                })
              } else {
                // get service data
                const location = {
                  lat: parseFloat(evt.mapPoint.latitude),
                  lng: parseFloat(evt.mapPoint.longitude)
                }
                vm.showwmspop = false
                const urlservice = window._env_.VUE_APP_BRAINS_API.replace('/api', '') + '/brainsmaps?'
                request({
                  url: urlservice + 'https://wms.cartografia.agenziaentrate.gov.it/inspire/ajax/ajax.php?op=getDatiOggetto&lon=' + location.lng + '&lat=' + location.lat,
                  method: 'get',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }).then((response) => {
                  vm.wmsdata = response.data
                  if (vm.wmsdata === []) {
                    vm.$message({
                      message: vm.$t('locationSelector.invalidlocation'),
                      type: 'error'
                    })
                    return
                  }
                  vm.showwmspop = true
                })
              }
            })
          })
        })
    },
    centermapposition() {
      const vm = this
      if (vm.currentMap === null) return
      if (this.position.latitude !== null) {
        loadModules(
          [
            'esri/Color',
            'esri/geometry/Circle',
            'esri/geometry/Point',
            'esri/geometry/Polygon',
            'esri/Graphic',
            'esri/symbols/SimpleFillSymbol',
            'esri/symbols/SimpleLineSymbol',
            'esri/layers/FeatureLayer',
            'esri/layers/GraphicsLayer'
          ],
          { css: true }
        ).then(([Color, Circle, Point, Polygon, Graphic, SimpleFillSymbol, SimpleLineSymbol, FeatureLayer, GraphicsLayer]) => {
          const wkid = 4258
          const centerPoint = new Point({
            longitude: vm.position.longitude,
            latitude: vm.position.latitude,
            spatialReference: {
              wkid: wkid
            }
          })

          const sym = {
            type: 'picture-marker',
            url: require('@/assets/brains_icons/pingeneral.svg'),
            width: '32px',
            height: '32px',
            yoffset: '15px'
          }

          vm.centerGraphic = new Graphic({
            geometry: centerPoint,
            symbol: sym,
            attributes: {
              tool: 'move'
            },
            spatialReference: {
              wkid: wkid
            }
          })

          vm.currentMapView.graphics.removeAll()
          vm.currentMapView.graphics.add(vm.centerGraphic)
          vm.currentMapView.center = centerPoint
          vm.$store.dispatch('maps/setmappoint', vm.currentMapView.center)
        })
      }
    },
    drawpois() {
      const vm = this
      let graphicsArray = []
      loadModules([
        'esri/geometry/Point',
        'esri/Graphic',
        'esri/symbols/SimpleLineSymbol',
        'esri/symbols/SimpleMarkerSymbol',
        'esri/layers/FeatureLayer'
      ], { css: true }).then(([Point, Graphic, SimpleLineSymbol, SimpleMarkerSymbol, FeatureLayer]) => {
        if (vm.currentMap === null) return
        const wkid = 4258
        // debugger
        graphicsArray = vm.currentMapPois.map((feature) => {
          return new Graphic({
            geometry: new Point({
              longitude: feature.longitude,
              latitude: feature.latitude
            }),
            attributes: {
              poi: feature,
              name: feature.name
            }
          })
        })

        var poiRenderer = {
          type: 'simple', // autocasts as new SimpleRenderer()
          symbol: {
            type: 'simple-marker',
            color: [0, 0, 255, 0.8],
            size: '10px',
            angle: 180,
            style: 'circle',
            outline: {
              color: [255, 255, 255],
              width: '1px'
            }
          }
        }

        const layer = new FeatureLayer({
          title: 'poispoints',
          objectIdField: 'name', // inferred from fields array if not specified
          geometryType: 'point', // geometryType and spatialReference are inferred from the first feature
          spatialReference: { wkid: wkid },
          source: graphicsArray,
          renderer: poiRenderer, // UniqueValueRenderer based on `type` attribute
          popupTemplate: {
            content: vm.popuptemplatepoi
          }
        })

        if (vm.poisGraphicView) {
          vm.currentMap.remove(vm.poisGraphicView)
        }
        vm.poisGraphicView = layer
        vm.currentMap.add(vm.poisGraphicView)
        vm.currentMapView.popup.close()
      })
    },
    popuptemplatepoi(item) {
      const vm = this
      const poi = vm.currentMapPois[item.graphic.attributes.name - 1]
      return '<div class="poistitle"><strong>' + poi.name + '</strong></div><div class="poistitle">' + vm.$t('distance') + ': ' + poi.distance + ' m</div>'
    },
    drawassets: function(changeZoom, resizeId) {
      const vm = this
      let graphicsArray = []
      loadModules([
        'esri/geometry/Point',
        'esri/Graphic',
        'esri/symbols/SimpleLineSymbol',
        'esri/symbols/SimpleMarkerSymbol'
      ], { css: true }).then(([Point, Graphic, SimpleLineSymbol, SimpleMarkerSymbol]) => {
        if (vm.currentMap === null) return
        // debugger
        // if (changeZoom) { vm.currentMapView.zoom = 6 }
        const wkid = 4258
        // Localizados
        var assets = []
        vm.usedTypos = []
        if (!!vm.currentAssets && vm.currentAssets.data !== undefined) {
          assets = vm.currentAssets.data.filter(item => { return item.BrainsLatitude !== null && item.BrainsLongitude !== null })
          if (assets.length === 0) { return }

          var resizeAssets = false
          var keyId = resizeId || ''
          if (keyId === '' && !!vm.currentAssets.stratsConfig) {
            if (!!vm.currentAssets.stratsConfig.areaoptions && vm.currentAssets.stratsConfig.areaoptions.length > 0) {
              keyId = vm.currentAssets.stratsConfig.areaoptions[0].id
            } else if (!!vm.currentAssets.stratsConfig.valueoptions && vm.currentAssets.stratsConfig.valueoptions.length > 0) {
              keyId = vm.currentAssets.stratsConfig.valueoptions[0].id
            }
          }
          if (keyId !== '') {
            resizeAssets = true
            // y1 - px minimos del punto en mapa
            // y2 - px máximos
            var y1 = 8
            var y2 = 20
            var x1 = _.min(assets, function(item) { return item[keyId] })[keyId]
            var x2 = _.max(assets, function(item) { return item[keyId] })[keyId]
          }

          var groupAssets = false
          var isBucket = false
          var groups = []
          if (vm.currentAssets.matchColumns && !!vm.currentAssets.matchColumns.some(s => s.brainsId.indexOf('sset_Features') > 0)) {
            groupAssets = true
            var obj = vm.currentAssets.matchColumns.find(f => f.brainsId.indexOf('sset_Features') > 0)
            if (obj.brainsSection === 'VALUES' || obj.brainsSection === 'DATES' || obj.brainsSection === 'TIMING' || obj.brainsSection === 'SURFACE') {
              isBucket = true
              var bucketMin = _.min(assets, function(item) { return item[vm.colorByProperty] })[vm.colorByProperty] ?? 0
              var bucketMax = _.max(assets, function(item) { return item[vm.colorByProperty] })[vm.colorByProperty]
              for (var i = bucketMin; i <= bucketMax; i += (bucketMax - bucketMin) / 5) {
                groups.push(i)
              }

              for (var j = 0; j < groups.length - 1; j++) {
                vm.usedTypos.push({
                  typo: vm.$formatNumber(groups[j], 0) + ' - ' + vm.$formatNumber(groups[j + 1], 0),
                  color: j < vm.assetColors.length ? vm.assetColors[j] : [234, 196, 40, 0.8]
                })
              }
            } else {
              var typoGroup = _.groupBy(assets, vm.colorByProperty)
              groups = Object.keys(typoGroup)
              groups = _.sortBy(groups, function(item) { return typoGroup[item].length }).reverse()

              for (var k = 0; k < groups.length; k++) {
                vm.usedTypos.push({
                  typo: groups[k],
                  color: k < vm.assetColors.length ? vm.assetColors[k] : [234, 196, 40, 0.8]
                })
              }
            }
          }

          graphicsArray = assets.map((feature) => {
            var intr = 10
            if (resizeAssets) {
              var x = feature[keyId]
              intr = y1 + ((y2 - y1) / (x2 - x1)) * (x - x1)
            }

            var colorGroup = [234, 196, 40, 0.8]
            if (groupAssets) {
              if (isBucket) {
                for (var i = 0; i < groups.length; i++) {
                  if (feature[vm.colorByProperty] >= groups[i] && feature[vm.colorByProperty] <= groups[i + 1]) {
                    colorGroup = i < vm.assetColors.length ? vm.assetColors[i] : [234, 196, 40, 0.8]
                    break
                  }
                }
              } else {
                var indexGroup = groups.indexOf(feature[vm.colorByProperty])
                colorGroup = indexGroup < vm.assetColors.length ? vm.assetColors[indexGroup] : [234, 196, 40, 0.8]
              }
            }
            // debugger
            var symbol = new SimpleMarkerSymbol({
              color: colorGroup,
              size: Math.round(intr) + 'px',
              angle: 180,
              style: 'circle',
              outline: new SimpleLineSymbol({
                color: [255, 255, 255],
                width: '1px'
              })
            })

            return new Graphic({
              geometry: new Point({
                longitude: feature.BrainsLongitude,
                latitude: feature.BrainsLatitude,
                spatialReference: {
                  wkid: wkid
                }
              }),
              symbol: symbol,
              attributes: {
                id_portfolio: feature.id,
                default_px: Math.round(intr) + 'px',
                default_colour: colorGroup
              },
              spatialReference: {
                wkid: wkid
              }
            })
          })
        }
        /*
        if (vm.currentAssets.country) {
          debugger
          var latLng = this.getCountryLatLng(vm.currentAssets.country)
          this.longitude = latLng[1]
          this.latitude = latLng[0]
        }
        */
        // debugger
        vm.portassetGraphicView.visible = true
        vm.portassetGraphicView.graphics = []
        vm.portassetGraphicView.graphics.addMany(graphicsArray)
      })
    },
    drawcomparables() {
      const vm = this
      const color_pub_sel = [216, 175, 70, 1]
      const color_pub = [232, 210, 128, 1]
      const color_unpub_sel = [194, 194, 194, 1]
      const color_unpub = [240, 240, 240, 1]
      loadModules(
        [
          'esri/Color',
          'esri/geometry/Circle',
          'esri/geometry/Point',
          'esri/geometry/Polygon',
          'esri/Graphic',
          'esri/symbols/SimpleFillSymbol',
          'esri/symbols/SimpleLineSymbol',
          'esri/layers/FeatureLayer',
          'esri/layers/GraphicsLayer',
          'esri/symbols/SimpleMarkerSymbol'
        ],
        { css: true }
      ).then(([Color, Circle, Point, Polygon, Graphic, SimpleFillSymbol, SimpleLineSymbol, FeatureLayer, GraphicsLayer, SimpleMarkerSymbol]) => {
        const assets = vm.currentComparables
        const wkid = 4258
        if (vm.currentMap === null) return
        // debugger
        if (vm.centerGraphicval !== null || vm.centerGraphic !== null) {
          vm.currentMapView.graphics.remove(vm.centerGraphicval)
        }
        const centerPoint = new Point({
          longitude: vm.currentFilterValuations.c_longitud,
          latitude: vm.currentFilterValuations.c_latitud,
          spatialReference: {
            wkid: wkid
          }
        })
        var grapharr = []
        var sym = {
          type: 'simple-fill', // autocasts as new SimpleFillSymbol()
          color: [216, 175, 70, 0.2],
          outline: {
            // autocasts as new SimpleLineSymbol()
            color: [216, 175, 70, 0.9],
            width: '0.5px'
          }
        }

        if (vm.edgeNPointGraphic) {
          vm.currentMapView.graphics.remove(vm.edgeNPointGraphic)
        }
        if (vm.edgeSPointGraphic) {
          vm.currentMapView.graphics.remove(vm.edgeSPointGraphic)
        }
        if (vm.edgeWPointGraphic) {
          vm.currentMapView.graphics.remove(vm.edgeWPointGraphic)
        }
        if (vm.edgeEPointGraphic) {
          vm.currentMapView.graphics.remove(vm.edgeEPointGraphic)
        }
        vm.edgeNPointGraphic = null
        vm.edgeSPointGraphic = null
        vm.edgeWPointGraphic = null
        vm.edgeEPointGraphic = null

        // radius
        if (vm.rings_search[0].length === 0) {
          vm.centerGraphicval = new Graphic(
            new Circle({
              center: centerPoint,
              radius: vm.currentFilterValuations.more_filters.search_radius,
              radiusUnit: 'meters',
              geodesic: true,
              attributes: { searchBy: 'circle', id: 'searchArea' },
              spatialReference: {
                wkid: wkid
              }
            }),
            sym
          )
          vm.edgeNPointGraphic = new Graphic({
            geometry: new Point({
              longitude: vm.currentFilterValuations.c_longitud,
              latitude: vm.centerGraphicval.geometry.extent.ymax,
              spatialReference: {
                wkid: wkid
              }
            }),
            symbol: new SimpleMarkerSymbol({
              color: 'white',
              size: 7,
              outline: {
                color: [136, 150, 0],
                width: '1px'
              }
            }),
            attributes: {
              tool: 'reshape',
              axis: 'y'
            }
          })
          vm.edgeSPointGraphic = new Graphic({
            geometry: new Point({
              longitude: vm.currentFilterValuations.c_longitud,
              latitude: vm.centerGraphicval.geometry.extent.ymin,
              spatialReference: {
                wkid: wkid
              }
            }),
            symbol: new SimpleMarkerSymbol({
              color: 'white',
              size: 7,
              outline: {
                color: [136, 150, 0],
                width: '1px'
              }
            }),
            attributes: {
              tool: 'reshape',
              axis: 'y'
            }
          })
          vm.edgeWPointGraphic = new Graphic({
            geometry: new Point({
              longitude: vm.centerGraphicval.geometry.extent.xmin,
              latitude: vm.currentFilterValuations.c_latitud,
              spatialReference: {
                wkid: wkid
              }
            }),
            symbol: new SimpleMarkerSymbol({
              color: 'white',
              size: 7,
              outline: {
                color: [136, 150, 0],
                width: '1px'
              }
            }),
            attributes: {
              tool: 'reshape'
            }
          })
          vm.edgeEPointGraphic = new Graphic({
            geometry: new Point({
              longitude: vm.centerGraphicval.geometry.extent.xmax,
              latitude: vm.currentFilterValuations.c_latitud,
              spatialReference: {
                wkid: wkid
              }
            }),
            symbol: new SimpleMarkerSymbol({
              color: 'white',
              size: 7,
              outline: {
                color: [136, 150, 0],
                width: '1px'
              }
            }),
            attributes: {
              tool: 'reshape'
            }
          })
          // fin radius
        } else {
          vm.centerGraphicval = new Graphic(new Polygon({
            centroid: centerPoint,
            rings: vm.rings_search,
            geodesic: true,
            attributes: { searchBy: 'polygon' },
            spatialReference: {
              wkid: wkid
            }
          }), sym)
        }

        grapharr.push(vm.centerGraphicval)
        if (vm.edgeNPointGraphic) {
          grapharr.push(vm.edgeNPointGraphic)
        }
        if (vm.edgeSPointGraphic) {
          grapharr.push(vm.edgeSPointGraphic)
        }
        if (vm.edgeWPointGraphic) {
          grapharr.push(vm.edgeWPointGraphic)
        }
        if (vm.edgeEPointGraphic) {
          grapharr.push(vm.edgeEPointGraphic)
        }

        // vm.currentMapView.graphics.add(vm.centerGraphicval)
        vm.currentMapView.graphics.addMany(grapharr)

        // vm.currentMapView.zoom = vm.getZoomByRadius(vm.currentFilterValuations.more_filters.search_radius)

        var dataArray = []
        assets.forEach(element => {
          var colorSym = []
          var bIsSelected = false
          var bIsPublished = false
          if (element.c_categoria === 'Publicados' && vm.selectedcomparables.some(s => s.iD_comparable === element.iD_comparable)) {
            colorSym = color_pub_sel
            bIsSelected = true
            bIsPublished = true
          } else if (element.c_categoria === 'Publicados') {
            colorSym = color_pub
            bIsPublished = true
          } else if (vm.selectedcomparables.some(s => s.iD_comparable === element.iD_comparable)) {
            colorSym = color_unpub_sel
            bIsSelected = true
          } else {
            colorSym = color_unpub
          }

          var symbol = new SimpleMarkerSymbol({
            color: colorSym,
            size: '10px',
            angle: 180,
            style: 'circle',
            outline: new SimpleLineSymbol({
              color: [255, 255, 255],
              width: '1px'
            })
          })

          var pointGraphic = new Graphic({
            geometry: new Point({
              longitude: element.c_longitud,
              latitude: element.c_latitud,
              spatialReference: {
                wkid: wkid
              }
            }),
            symbol: symbol,
            attributes: {
              iD_comparable: element.iD_comparable,
              active: bIsSelected,
              pub: bIsPublished
            }
          })

          dataArray.push(pointGraphic)
        })
        vm.assetGraphicView.graphics = []
        vm.assetGraphicView.graphics.addMany(dataArray)
      })
    }
  }
})
